import { render, staticRenderFns } from "./select-edit.vue?vue&type=template&id=db5f68c6"
import script from "./select-edit.vue?vue&type=script&lang=js"
export * from "./select-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports